import type { LocationQuery } from 'vue-router'
import type { ProgramId } from '~/data/programs'

export function getProgrammeIdFromQuery(query: LocationQuery): ProgramId {
  // Extract the programmeId from the query object
  let programmeId = query.programme // The new query parameter
  if (!programmeId) {
    programmeId = query.specialProgram // The old query parameter, keep this until the old site is deprecated
  }
  // Map the programmeId to the correct value
  if (programmeId === 'kydp-b') {
    // Old site value
    return 'kydp-2024-b' // keep this until the old site is deprecated
  }
  return programmeId as ProgramId
}
